// @flow
import { Settings } from "@mui/icons-material";
import { Fab } from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Permissions } from "../../../../../../helpers/constants";
import { getRouteUrl } from "../../../../../../helpers/getRouteUrl";
import useMenuData from "../../../../../../hooks/menu/useMenuData";
import { EXHIBITION } from "../../../../../../locales/components/namespaces";
import PermissionHOC from "../../../../../../modules/permission/components/permissionHOC/permissionHOC";
import { ROUTE_PAGE_EXHIBITION_SETTINGS } from "../../../../../../routers/routes";

type Props = {};

const WrapperWithSettingsButton = (props: Props) => {
	const { id, hideSettingsButton = false } = props
	const { drawerOpen } = useMenuData()
	const { t } = useTranslation(EXHIBITION)
	return (
		<>
			{props.children}
			{!hideSettingsButton && (
				<PermissionHOC requiredPermissions={[Permissions.BeOrganizer]}>
					<Link
						to={getRouteUrl(ROUTE_PAGE_EXHIBITION_SETTINGS, { id: id })}>
						<Fab
							color="info"
							variant="extended"
							size="medium"
							sx={{
								position: "fixed",
								bottom: 16,
								left: drawerOpen ? 32 : 16,
								zIndex: 1050,
							}}
						>
							<Settings/>
							{drawerOpen && (
								<Typography
									variant={'body1'}
									component={'div'}
									ml={0.2}
								>
									{t('Exhibition Settings')}
								</Typography>
							)}
						</Fab>
					</Link>
				</PermissionHOC>
			)}
		</>
	);
};

export default WrapperWithSettingsButton